var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center__wrapper"},[(_vm.component)?_c(_vm.component,_vm._b({tag:"component"},'component',_vm.componentProps,false)):_c('div',{staticClass:"styled-label"},[_vm._v("Not a component...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }